import { render } from "./menu1-2-1.vue?vue&type=template&id=3d2fd980"
import script from "./menu1-2-1.vue?vue&type=script&lang=ts"
export * from "./menu1-2-1.vue?vue&type=script&lang=ts"
script.render = render

export default script